export default __webpack_public_path__ + "static/media/innovation.655f74b6.jpg";